import { render, staticRenderFns } from "./GlobalSubPhasesContainer.vue?vue&type=template&id=27e85149&"
import script from "./GlobalSubPhasesContainer.vue?vue&type=script&lang=ts&"
export * from "./GlobalSubPhasesContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports